import { Col, Row } from "antd";
import { useEffect } from "react";
import CustomTable from "../customTable/CustomTable";
import ECharts from "../ECharts/ECharts";
import Spiner from "../Spiner/Spiner";

export function ReportTap({ chartData, tableData, columns, onPathChange, path, total, loading, flow, onPageChange }) {

    useEffect(() => {
        // get data from api when tab Change
        onPathChange(path)
    }, [path])

    const option = {
        baseOption: {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 0,
                bottom: 'center',
                type: 'scroll',

            },

            series: [
                {
                    name: 'Report',
                    type: 'pie',
                    radius: [60, 100],
                    center: ['65%', '50%'],

                    label: {

                        show: false,
                        formatter: (item) => {
                            if (item.name.length > 20) {
                                return `${item.name.slice(0, 20)} ...\n ${item.value} (${item.percent}%) `;
                            }
                            return `${item.name} \n ${item.value}(${item.percent}%) `;
                        },
                    },
                    emphasis: {
                        label: {
                            show: true,
                        },
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    labelLine: {
                        length: 10,
                        length2: 50,
                        maxSurfaceAngle: 10
                    },
                    data: chartData,
                }
            ]
        },
        media: [
            {
                query: {
                    maxWidth: 700,
                },
                option: {
                    radius: [30, 100],
                    legend: {
                        orient: 'horizontal',
                        left: 'center',
                        bottom: 0,

                    },
                    series: [{
                        labelLine: {
                            length: 30,
                            length2: 20,
                            maxSurfaceAngle: 10
                        },
                        center: ['50%', '50%'],
                    }]

                }

            }
        ]

    }

    return (
        <>
            {flow ?
                <CustomTable data={tableData} columns={columns} loading={loading} /> :
                <Row wrap style={{ minHieght: 500 }}>
                    <Col md={{ span: 14 }} xs={{ span: 24 }} >
                        {loading ? <Spiner /> : <ECharts option={option} />}
                    </Col>
                    <Col md={{ span: 10 }} xs={{ span: 24 }}>
                        <CustomTable data={tableData} columns={columns} loading={loading} total={total} pagination perPage={6} onPageChange={onPageChange} />
                    </Col>
                </Row>
            }

        </>
    )
}